const helpPopupMixin = {
    data() {
        return {};
    },
    methods: {
        showCurrentVideo(key) {
            let currentLang = localStorage.getItem('lang')
            if (currentLang == 'ru' && key == 'manage') {
                this.welcomeModalSettings = {
                    video: 'v_kebab_ru.mp4',
                }
            } else if (currentLang == 'uk' && key == 'manage') {
                this.welcomeModalSettings = {
                    video: 'v_kebab_ua.mp4',
                }
            } else if (currentLang == 'de' && key == 'manage') {
                this.welcomeModalSettings = {
                    video: 'v_kebab_de.mp4',
                }
            } else {
                this.welcomeModalSettings = {
                    video: 'v_kebab_en.mp4',
                }
            }
            if (key == 'feedback') {
                this.welcomeModalSettings = {
                    video: 'v_coffeeshop.mp4',
                }
            }
            if (key == 'alerts') {
                this.welcomeModalSettings = {
                    video: 'v_alerts_en.mp4',
                }
            }
            return this.welcomeModalSettings.video
        },
        getManagePopupSettings(key) {
            return  {
                show: true,
                icon: 'managePopupIcon.svg',
                title: this.translate('showManagePopupTitle'),
                subtitle: this.translate('showManagePopupSubtitle'),
                video: this.showCurrentVideo(key),
                key: key,
            }
        },
        getFeedbackPopupSettings(key) {
            return {
                show: true,
                icon: 'feedbackPopupIcon.svg',
                title: this.translate('showFeedbackPopupTitle'),
                subtitle: this.translate('showFeedbackPopupSubtitle'),
                video: this.showCurrentVideo(key),
                key: key
            }
        },
        getAlertPopupSettings(key) {
           return {
               show: true,
               icon: 'alertPopupIcon.svg',
               title: this.translate('showAlertsPopupTitle'),
               subtitle: this.translate('showAlertsPopupSubtitle'),
               video: this.showCurrentVideo(key),
               key: key
           }
        }
    }
}
export default helpPopupMixin